import { Injectable } from '@angular/core';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { StaffBasicInfo } from '@models/global-entities/global-entities';
import {
  EntityCodes,
  EntityActions,
} from '@models/global-entities/global-enums';
@Injectable({
  providedIn: 'root',
})
export class UserAnalyticsService {
  constructor(private gaService: GoogleAnalyticsService) {}

  updateUserProperties(user: StaffBasicInfo) {
    this.gaService.set({
      propertyId: user?.PropertyId,
      domain: window.location.hostname,
    });
  }

  didUpdateEntity(entity: EntityCodes, action: string, label?: string) {
    this.gaService.event(action, entity, label);
  }
}
